// extracted by mini-css-extract-plugin
export default {"fileItem":"file-item_fileItem__EmP88","icon":"file-item_icon__0G1EY","name":"file-item_name__UwzQa","actions":"file-item_actions__y9FNr"};